import getters from './getters'
import mutations from './mutations'
import actions from './actions'

export default {
  state: {
    serviceCategory: null,
    serviceCategories: [],
    serviceCategoryErrors: null,
    serviceCategoryFilters: null,
    serviceWithWorkplaces: [],
    serviceWithoutGroups: [],
    shortServiceCategories: [],
  },
  getters: getters,
  mutations: mutations,
  actions: actions,
}
